/* Vlastni chovani kosiku a produktove stranky pro Laura Sydney.
   Drive byly tyhle skripty vlozene primo v HTML kazde stranky (asi 17 kB),
   coz zdrzovalo prvni vykresleni na telefonu. Ted je to jeden soubor s defer:
   prohlizec ho stahne soubezne a spusti az po nacteni stranky.
   Vsechny casti si samy overi, jestli jejich prvek na strance existuje. */

/* ---- odpocet rezervace ---- */
if (!window.__chReservedInit) {
  window.__chReservedInit = true;
  (function(){
    var DUR = 599;
    var start = parseInt(sessionStorage.getItem('chReservedStart') || '0', 10);
    var now = Math.floor(Date.now() / 1000);
    if (!start || now - start > DUR * 2) { start = now; sessionStorage.setItem('chReservedStart', String(start)); }
    function tick(){
      var left = Math.max(0, DUR - (Math.floor(Date.now() / 1000) - start));
      if (left <= 0) {
        document.querySelectorAll('.ch-reserved').forEach(function(el){ el.style.display = 'none'; });
        return;
      }
      var m = Math.floor(left / 60), s = left % 60;
      var txt = m + ':' + (s < 10 ? '0' : '') + s;
      document.querySelectorAll('[data-ch-reserved-time]').forEach(function(el){ el.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  })();
}

/* ---- rychly vyber varianty ---- */
window.ChQuickAdd = (function () {
  var root = document.getElementById('ChQuickAdd');
  if (!root) return { open: function () {} };
  var body = root.querySelector('[data-ch-qa-body]');
  var cache = {}, state = null;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }
  function titleCase(s) { return s.toLowerCase().replace(/(^|[\s-])\S/g, function (c) { return c.toUpperCase(); }); }
  function splitTitle(t) {
    t = (t || '').replace(/™/g, '').trim();
    var m = t.match(/^(.+?)\s*[-|–—]\s*(.+)$/);
    var name = m ? m[1] : t, desc = m ? m[2] : '';
    if (name === name.toUpperCase()) name = titleCase(name);
    if (desc && desc === desc.toUpperCase()) desc = titleCase(desc);
    return { name: name.trim(), desc: desc.trim() };
  }
  function imgUrl(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function open(handle) {
    show();
    body.innerHTML = '<div class="ch-qa__loading">Loading…</div>';
    (cache[handle] ? Promise.resolve(cache[handle]) : fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }))
      .then(function (p) { cache[handle] = p; render(p); })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  function render(p) {
    var t = splitTitle(p.title);
    var images = (p.images && p.images.length) ? p.images : [];
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    state = { p: p, sel: [first.option1, first.option2, first.option3], img: 0 };
    var html = '';
    html += '<div class="ch-qa__media">';
    html += '<div class="ch-qa__imgwrap"><img class="ch-qa__img" src="' + imgUrl(images[0], 900) + '" alt=""></div>';
    if (images.length > 1) {
      html += '<button type="button" class="ch-qa__arrow ch-qa__arrow--prev" data-ch-qa-prev aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="m15 18-6-6 6-6"/></svg></button>';
      html += '<button type="button" class="ch-qa__arrow ch-qa__arrow--next" data-ch-qa-next aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="m9 18 6-6-6-6"/></svg></button>';
      html += '<div class="ch-qa__dots">' + images.map(function (_, i) { return '<span class="ch-qa__dot' + (i === 0 ? ' is-active' : '') + '"></span>'; }).join('') + '</div>';
    }
    html += '</div>';
    html += '<div class="ch-qa__info">';
    html += '<p class="ch-qa__name">' + esc(t.name) + '</p>';
    if (t.desc) html += '<p class="ch-qa__desc">' + esc(t.desc) + '</p>';
    html += '<p class="ch-qa__price" data-ch-qa-price></p>';
    html += '<div class="ch-qa__options">';
    (p.options || []).forEach(function (o, oi) {
      if (o.values.length === 1 && o.values[0] === 'Default Title') return;
      html += '<div class="ch-qa__opt" data-opt-index="' + oi + '"><p class="ch-qa__opt-label">' + esc(o.name) + ': <span data-ch-qa-optval></span></p><div class="ch-qa__values">';
      o.values.forEach(function (v) {
        html += '<button type="button" class="ch-qa__val" data-val="' + esc(v) + '">' + esc(v) + '</button>';
      });
      html += '</div></div>';
    });
    html += '</div>';
    html += '<button type="button" class="ch-qa__add" data-ch-qa-add>ADD TO CART</button>';
    html += '<a class="ch-qa__details" href="/products/' + p.handle + '">View details</a>';
    html += '</div>';
    body.innerHTML = html;
    body.querySelectorAll('.ch-qa__val').forEach(function (b) {
      b.addEventListener('click', function () {
        var oi = parseInt(b.closest('.ch-qa__opt').dataset.optIndex, 10);
        state.sel[oi] = b.dataset.val;
        sync();
      });
    });
    var prev = body.querySelector('[data-ch-qa-prev]'), next = body.querySelector('[data-ch-qa-next]');
    if (prev) prev.addEventListener('click', function () { showImg(state.img - 1); });
    if (next) next.addEventListener('click', function () { showImg(state.img + 1); });
    body.querySelector('[data-ch-qa-add]').addEventListener('click', add);
    sync();
  }

  function variantFor(sel) {
    return state.p.variants.filter(function (v) {
      return (v.option1 || null) === (sel[0] || null) && (v.option2 || null) === (sel[1] || null) && (v.option3 || null) === (sel[2] || null);
    })[0];
  }
  function sync() {
    var p = state.p, v = variantFor(state.sel);
    body.querySelectorAll('.ch-qa__opt').forEach(function (optEl) {
      var oi = parseInt(optEl.dataset.optIndex, 10);
      optEl.querySelector('[data-ch-qa-optval]').textContent = state.sel[oi] || '';
      optEl.querySelectorAll('.ch-qa__val').forEach(function (b) {
        var trial = state.sel.slice(); trial[oi] = b.dataset.val;
        var tv = variantFor(trial);
        b.classList.toggle('is-selected', b.dataset.val === state.sel[oi]);
        b.classList.toggle('is-unavailable', !tv || !tv.available);
      });
    });
    var priceEl = body.querySelector('[data-ch-qa-price]');
    var price = v ? v.price : p.price, cmp = v ? v.compare_at_price : p.compare_at_price;
    priceEl.innerHTML = (cmp && cmp > price ? '<s>' + money(cmp) + '</s> ' : '') + '<span>' + money(price) + '</span>';
    var add = body.querySelector('[data-ch-qa-add]');
    add.disabled = !v || !v.available;
    add.textContent = (!v || !v.available) ? 'SOLD OUT' : 'ADD TO CART';
    // Shopify vraci u varianty absolutni URL (https://cdn...), ale v p.images relativni (//cdn...),
    // takze prosty indexOf se nikdy netrefil a fotka pri zmene barvy nepreskocila.
    if (v && v.featured_image) showImg(imageIndexFor(v.featured_image));
  }
  function sameImage(a, b) {
    var norm = function (u) { return String(u || '').replace(/^https?:/, '').split('?')[0]; };
    return norm(a) === norm(b);
  }
  function imageIndexFor(fi) {
    if (!fi) return -1;
    if (typeof fi.position === 'number' && fi.position >= 1 && fi.position <= state.p.images.length) {
      return fi.position - 1;
    }
    for (var i = 0; i < state.p.images.length; i++) {
      if (sameImage(state.p.images[i], fi.src)) return i;
    }
    return -1;
  }
  function showImg(i) {
    var imgs = state.p.images; if (!imgs.length || i < 0) return;
    i = (i + imgs.length) % imgs.length; state.img = i;
    body.querySelector('.ch-qa__img').src = imgUrl(imgs[i], 900);
    body.querySelectorAll('.ch-qa__dot').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
  }

  function add() {
    var v = variantFor(state.sel); if (!v) return;
    var btn = body.querySelector('[data-ch-qa-add]');
    btn.disabled = true; btn.textContent = 'ADDING…';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        close();
        var drawer = document.getElementById('CartDrawer');
        if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (drawer && !drawer.classList.contains('drawer--is-open')) {
          var opener = document.querySelector('.js-drawer-open-cart'); if (opener) opener.click();
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'ADD TO CART'; });
  }

  function show() { root.hidden = false; root.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('ch-qa-open'); }
  function close() { root.hidden = true; root.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('ch-qa-open'); }
  root.querySelectorAll('[data-ch-qa-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  return { open: open, close: close };
})();

/* ---- doporucene v kosiku ---- */
(function () {
  var root = document.querySelector('[data-ch-fbt]');
  if (!root) return;
  var track = root.querySelector('[data-ch-fbt-track]');
  var dots = root.querySelector('[data-ch-fbt-dots]');
  var LIMIT = 6, cache = {}, lastKey = null, loading = false;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }
  function titleCase(s) {
    return s.toLowerCase().replace(/(^|[\s-])\S/g, function (c) { return c.toUpperCase(); });
  }
  function splitTitle(t) {
    t = (t || '').replace(/™/g, '').trim();
    var m = t.match(/^(.+?)\s*[-|–—]\s*(.+)$/);
    var name = m ? m[1] : t, desc = m ? m[2] : '';
    if (name === name.toUpperCase()) name = titleCase(name);
    if (desc && desc === desc.toUpperCase()) desc = titleCase(desc);
    return { name: name.trim(), desc: desc.trim() };
  }
  function img(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }
  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function load(cart) {
    var inCart = {}, first = null;
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; if (!first) first = i.product_id; });
    if (!first) { root.hidden = true; return; }
    var key = first + ':' + Object.keys(inCart).join(',');
    if (key === lastKey) return;
    if (cache[first]) { render(cache[first], inCart); lastKey = key; return; }
    if (loading) return;
    loading = true;
    fetchJson('/recommendations/products.json?product_id=' + first + '&limit=10&intent=related')
      .then(function (d) {
        var list = (d && d.products) || [];
        if (list.length >= 3) return list;
        return fetchJson('/collections/all/products.json?limit=12').then(function (d2) {
          var seen = {}; list.forEach(function (p) { seen[p.id] = 1; });
          ((d2 && d2.products) || []).forEach(function (p) { if (!seen[p.id]) list.push(p); });
          return list;
        });
      })
      .then(function (list) { cache[first] = list; lastKey = key; render(list, inCart); })
      .catch(function () { root.hidden = true; })
      .then(function () { loading = false; });
  }

  function render(list, inCart) {
    var items = list.filter(function (p) { return p.available !== false && !inCart[p.id] && (p.featured_image || (p.images && p.images[0])); }).slice(0, LIMIT);
    track.innerHTML = ''; dots.innerHTML = '';
    if (!items.length) { root.hidden = true; return; }
    items.forEach(function (p, i) {
      var t = splitTitle(p.title);
      var image = p.featured_image || (p.images && p.images[0]) || '';
      var price = typeof p.price === 'number' ? p.price : parseInt(p.price, 10);
      var cmp = p.compare_at_price ? (typeof p.compare_at_price === 'number' ? p.compare_at_price : parseInt(p.compare_at_price, 10)) : 0;
      var card = document.createElement('div');
      card.className = 'ch-fbt__card';
      card.innerHTML =
        '<a class="ch-fbt__imgwrap" href="/products/' + p.handle + '"><img class="ch-fbt__img" loading="lazy" alt="" src="' + img(image) + '"></a>' +
        '<div class="ch-fbt__body">' +
          '<p class="ch-fbt__name">' + t.name + '</p>' +
          (t.desc ? '<p class="ch-fbt__desc">' + t.desc + '</p>' : '') +
          '<p class="ch-fbt__price">' + (cmp > price ? '<s>' + money(cmp) + '</s>' : '') + money(price) + '</p>' +
          '<button type="button" class="ch-fbt__add">+ Add</button>' +
        '</div>';
      card.querySelector('.ch-fbt__add').addEventListener('click', function () { openQuick(p); });
      track.appendChild(card);
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ch-fbt__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Product ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dots.appendChild(dot);
    });
    track.scrollLeft = 0;
    root.hidden = false;
  }

  function step() { var c = track.firstElementChild; return c ? c.offsetWidth + 10 : 1; }
  function markDot(idx) {
    Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
  }
  function goTo(i) {
    var n = track.children.length; if (!n) return;
    i = (i + n) % n;
    track.scrollLeft = i * step();
    markDot(i);
  }
  function current() { return Math.round(track.scrollLeft / step()); }
  root.querySelector('[data-ch-fbt-prev]').addEventListener('click', function () { goTo(current() - 1); });
  root.querySelector('[data-ch-fbt-next]').addEventListener('click', function () { goTo(current() + 1); });
  // kolecko mysi na desktopu posouva vodorovne (jinak by se karty daly prepinat jen teckami)
  track.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { track.scrollLeft += e.deltaY; e.preventDefault(); }
  }, { passive: false });
  track.addEventListener('scroll', function () { markDot(current()); }, { passive: true });

  // Quick View: stejny modal, jaky Impulse pouziva v mrizce produktu (tam jen na desktopu, tady i na mobilu)
  function openQuick(p) {
    if (window.ChQuickAdd) { ChQuickAdd.open(p.handle); return; }
    var modalId = 'QuickShopModal-' + p.id;
    var modal = document.getElementById(modalId);
    if (!modal) {
      modal = document.createElement('div');
      modal.id = modalId;
      modal.className = 'modal modal--square modal--quick-shop';
      modal.setAttribute('data-product-id', p.id);
      modal.innerHTML =
        '<div class="modal__inner"><div class="modal__centered"><div class="modal__centered-content">' +
        '<div id="QuickShopHolder-' + p.handle + '"></div></div>' +
        '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '<span class="icon__fallback-text">Close</span></button></div></div>';
      document.body.appendChild(modal);
    }
    var holder = document.getElementById('QuickShopHolder-' + p.handle);
    var ready = holder.dataset.loaded
      ? Promise.resolve()
      : fetch('/products/' + p.handle + '?view=modal').then(function (r) { return r.text(); }).then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var div = html.querySelector('.product-section[data-product-handle="' + p.handle + '"]');
          if (!div) throw new Error('no modal template');
          holder.innerHTML = '';
          holder.appendChild(div);
          holder.dataset.loaded = '1';
          if (theme.sections && theme.sections.register) theme.sections.register('product', theme.Product, holder);
          if (theme.collapsibles && theme.collapsibles.init) theme.collapsibles.init();
        });
    ready.then(function () {
      if (!modal.chModal) modal.chModal = new theme.Modals(modalId, 'quick-modal-' + p.id);
      modal.chModal.open();
    }).catch(function () { window.location.href = '/products/' + p.handle; });
  }

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () { fetchJson('/cart.js').then(function (c) { if (c) load(c); }); }, 150);
  }
  document.addEventListener('drawerOpen', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('ajaxProduct:added', refresh);
  // Impulse prekresluje polozky kosiku pri kazde zmene; to je nejspolehlivejsi signal
  var products = document.querySelector('#CartDrawerForm [data-products]');
  if (products && window.MutationObserver) {
    new MutationObserver(refresh).observe(products, { childList: true });
  }
  if (document.readyState === 'complete') refresh(); else window.addEventListener('load', refresh);
})();

/* ---- banner slev v kosiku ---- */
(function(){
    var bar = document.querySelector('[data-ch-cartbar]');
    if (!bar) return;
    var msg = bar.querySelector('[data-ch-cartbar-msg]');
    var stops = bar.querySelectorAll('.ch-tier');
    var tiers = [[2,10],[3,15],[4,20],[5,25]];
    function update(count){
      count = parseInt(count || 0, 10);
      stops.forEach(function(s){ s.classList.toggle('is-reached', count >= parseInt(s.dataset.min, 10)); });
      var next = null;
      for (var i = 0; i < tiers.length; i++) { if (count < tiers[i][0]) { next = tiers[i]; break; } }
      if (!next) {
        msg.innerHTML = "<mark>You've unlocked the maximum <b>EXTRA 25% off</b>!</mark>";
      } else {
        var need = next[0] - count;
        msg.innerHTML = '<mark>Add ' + need + ' more item' + (need > 1 ? 's' : '') + ' to get an <b>EXTRA ' + next[1] + '% off</b></mark>';
      }
    }
    update(bar.dataset.initialCount);
    var products = document.querySelector('#CartDrawerForm [data-products]');
    if (products) {
      new MutationObserver(function(){
        var items = products.querySelector('.cart__items');
        if (items) update(items.dataset.count);
      }).observe(products, {childList: true, subtree: true});
    }
    document.addEventListener('cart:updated', function(e){
      var c = e.detail && (e.detail.cart || e.detail);
      if (c && typeof c.item_count !== 'undefined') update(c.item_count);
    });
  })();

/* ---- mazani polozek a posun v kosiku ---- */
(function(){
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    // Kos: smazat pres AJAX, prekreslit kosik, zadne nacitani stranky
    drawer.addEventListener('click', function(e){
      var a = e.target.closest('.ch-cart-remove');
      if (!a || !window.theme || !theme.cart) return;
      e.preventDefault();
      var key = new URL(a.getAttribute('href'), location.origin).searchParams.get('id');
      var item = a.closest('.cart__item'); if (item) item.style.opacity = '.4';
      theme.cart.changeItem(key, 0).then(function(txt){
        var cart = JSON.parse(txt);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      }).catch(function(){ if (item) item.style.opacity = ''; });
    });
    // Mobil: prst na hlavicce nebo paticce draweru nesmi scrollovat stranku pod nim
    drawer.addEventListener('touchmove', function(e){
      if (!e.target.closest('.drawer__scrollable, .ch-fbt__track')) e.preventDefault();
    }, { passive: false });
  })();

/* ---- datum odeslani na produktu ---- */
(function () {
  var el = document.querySelector('[data-ch-dispatch-date]');
  if (!el) return;
  var d = new Date(Date.now() + 86400000);
  try {
    el.textContent = d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
  } catch (e) {}
})();
